import React from 'react'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'

import Modal from 'Components/Modal'

import Gestion from './Gestion'
import NavLink from 'Components/NavLink'

import Search from 'Components/Search'

class Filtre extends React.Component {

  constructor (props) {
    super(props)
    const filtre_id = localStorage.getItem('filtre_' + props.search)
    const myFiltre = filtre_id && Data.get(Constants.module.PRIVEE, Constants.donnee.filtre, {
      module: this.props.module,
      donnee: this.props.donnee,
      id: filtre_id
    })
    this.state = {
      showGestion: false,
      filtre_id: myFiltre && parseInt(filtre_id) || undefined
    }
  }

  onClickGestion = view => _ => {
    this.setState({
      showGestion: view
    })
  }

  onSelectFiltre = (id) => _ => {
    localStorage.setItem('filtre_' + this.props.search, id)
    this.setState({
      filtre_id: id
    })
  }

  render () {
    const filtres = Data.list(Constants.module.PRIVEE, Constants.donnee.filtre, {
      module: this.props.module,
      donnee: this.props.donnee
    })
    const search = this.state.filtre_id && filtres.find(f => f.id === this.state.filtre_id) && JSON.parse(filtres.find(f => f.id === this.state.filtre_id).json) || {}
    return (
      <Grid container className={'react-sanfona-item-body-wrapper'} spacing={0} style={{ margin: 0, padding: 0, position: 'relative' }}>
        <i className={'btn ei-commun_configuration EurestoPrimary--text'}
           style={{ position: 'absolute', right: 7.5, top: -24 }} onClick={this.onClickGestion(true)}/>
        <Search
          unsave
          key={this.state.filtre_id}
          style={{ fontSize: 12, padding: 2, right: 0, position: 'absolute', top: -60 }}
          limit={30}
          defaultSearchPriority
          defaultSearch={search}
          requete={this.props.donnee}
          search={this.props.search}
          path={this.props.module}>
        </Search>
        {
          filtres.map(filtre =>
            <NavLink
              style={{lineHeight: 1, borderRadius: 5}}
              onClick={this.onSelectFiltre(filtre.id)}
              className={'ssMenu menu-item cursor-pointer ' + (filtre.id === this.state.filtre_id && 'page-layout__nav-item--active' || '')}><span>{filtre.libelle}</span>
            </NavLink>
          )
        }
        <Modal grid={{xs: 11}} key={this.state.showGestion} open={this.state.showGestion} onClose={this.onClickGestion(false)}>
          <Gestion defaultSearch={this.state.search} module={this.props.module} donnee={this.props.donnee} path={this.props.module} name={this.props.search} />
        </Modal>
      </Grid>
    )
  }

}

export default Filtre



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Filtre/index.js